import { render, staticRenderFns } from "./DeleteSingleDialog.vue?vue&type=template&id=40ddf33c"
import script from "./DeleteSingleDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSingleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports